import { all, fork } from "redux-saga/effects";

import loadAuthSaga from "./auth.saga";
import loadChatSaga from "./chat.saga";
import loadCodeEditorSaga from "./codeEditor.saga";
import loadCodingProblemsSaga from "./codingProblems.saga";
import loadInterviewSaga from "./interview.saga";
import loadInterviewerRatingsSaga from "./interviewerRatings.saga";
import loadProblemsSaga from "./library.saga";
import loadMoveToLobbySaga from "./moveToLobby.saga";
import loadParticipantSaga from "./participants.saga";
import loadQuestionsSaga from "./questions.saga";
import loadSolutionsSaga from "./solutions.saga";
import loadZoomClientSaga from "./zoomClient.saga";
import loadCollabTemporaryDataSaga from "./collabTemporaryData.saga";
import loadPlatformMetaSaga from "./platformMeta.saga";
import loadServerTime from "./serverTime.saga";
import loadSubjectiveSolutionSaga from "./subjectiveSolution.saga";
import loadInterviewConfigSaga from "./interviewConfig.saga";

export default function* rootSaga() {
  yield all([
    fork(loadAuthSaga),
    fork(loadZoomClientSaga),
    fork(loadChatSaga),
    fork(loadProblemsSaga),
    fork(loadQuestionsSaga),
    fork(loadInterviewSaga),
    fork(loadInterviewerRatingsSaga),
    fork(loadSolutionsSaga),
    fork(loadCodingProblemsSaga),
    fork(loadCodeEditorSaga),
    fork(loadParticipantSaga),
    fork(loadMoveToLobbySaga),
    fork(loadCollabTemporaryDataSaga),
    fork(loadPlatformMetaSaga),
    fork(loadServerTime),
    fork(loadSubjectiveSolutionSaga),
    fork(loadInterviewConfigSaga),
  ]);
}
